export class DownloadHelper {
    public download(name: string, blob: Blob) {
        if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, name);
        }

        var a = document.createElement('a');
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }, 0);
    }
    public parseBlob(b64Data: any, sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return byteArrays;
    }
    public makeCsv(headers: any[] | null, rows: any[][]) {
        if (headers != null) { rows.unshift(headers); }
        var safeval = (c: any) => {
            if (c == null || c == undefined) {
                return '';
            }
            if (c && c.replace) {
                return c.replace('"', '""').replace(/\n/g, ' ').replace(/\r/g, ' ');
            }
            return `${c}`;
        };
        var csv = rows.map(r => r.map(safeval).join('|')).join('\n');
        return 'sep=|\n' + csv;
    }
}

export default new DownloadHelper();
